import React from 'react';
import { Button, Col, Form, Row, Stack } from 'react-bootstrap';
import { formatPlaceholder } from '../../lib/utils';

const AutomationDetailsForm = ({
  data,
  handleChange,
  handleSave,
  showAuthToken,
  setShowAuthToken,
  error,
  labels,
  submitting,
  readOnly,
}) => {
  return (
    <>
      <Row>
        <Col>
          <Form.Label className="required">{labels.urlLabel}</Form.Label>
          {readOnly ? (
            <p>{data[labels.urlPlaceholder] || formatPlaceholder()}</p>
          ) : (
            <Form.Control
              type="text"
              id={labels.urlPlaceholder}
              onChange={handleChange}
              value={data[labels.urlPlaceholder]}
              placeholder={`Enter ${labels.urlLabel}`}
              required
            />
          )}
        </Col>
        <Col>
          <Form.Label className="required">{labels.usernameLabel}</Form.Label>
          {readOnly ? (
            <p>{data[labels.usernamePlaceholder] || formatPlaceholder()}</p>
          ) : (
            <Form.Control
              type="text"
              id={labels.usernamePlaceholder}
              onChange={handleChange}
              value={data[labels.usernamePlaceholder]}
              placeholder={`Enter ${labels.usernameLabel}`}
              required
            />
          )}
        </Col>

        <Col>
          {!readOnly && (
            <>
              <Form.Label className="required">{labels.tokenLabel}</Form.Label>
              <Form.Control
                type={showAuthToken ? 'text' : 'password'}
                id={labels.tokenPlaceholder}
                onChange={handleChange}
                value={data[labels.tokenPlaceholder]}
                placeholder={`Enter ${labels.tokenLabel}`}
                required
                readOnly={readOnly}
              />
              <Form.Check
                type="checkbox"
                label="Show Token"
                checked={showAuthToken}
                onChange={() => setShowAuthToken(!showAuthToken)}
                className="mt-2"
              />
            </>
          )}
        </Col>
      </Row>

      {error && <p className="text-danger">* {error}</p>}
      {!readOnly && (
        <Row className="mt-4">
          <Col className="d-flex justify-content-center">
            <Button
              variant="primary"
              onClick={handleSave}
              disabled={submitting}>
              {submitting ? 'Saving...' : 'Save Details'}
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};

export default AutomationDetailsForm;
